import React, { ButtonHTMLAttributes, FC, forwardRef, Ref } from "react";
import Icon, { IconTypes } from "../../libs/Icon";
import cx from "classnames";

import styles from "./styles.module.scss";

interface IconButtonProps {
  type: IconTypes;
  size?: number;
  className?: string;
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

const IconButton: FC<IconButtonProps> = forwardRef(
  ({ type, size, className, buttonProps }, ref: Ref<HTMLButtonElement>) => {
    return (
      <button
        type="button"
        className={cx(styles.iconButton, className)}
        ref={ref}
        {...buttonProps}
      >
        <Icon type={type} size={size} />
      </button>
    );
  }
);

export default IconButton;
